import React, { forwardRef, useImperativeHandle, useState } from 'react';

import service from '../../service/authorization';
import { Horizontal, Center } from './Layout';
import { useAccountFactory, useMobileFactory } from './Factory';
import { Background, Tabs, Copyright, Download, Logo, PKIButton, PKIdownload, Logout } from './Component';
import { LoginProps } from './types';
import LoginContext from './context';

const { impl: { basic } } = service;

export {
  // Factory
  useAccountFactory,
  useMobileFactory,
  LoginContext,
  // Component
  Background, Tabs, Copyright, Download, Logo, PKIButton, PKIdownload, Logout,
}

const Login: React.FC<LoginProps & { ref?: any }> = forwardRef((props: LoginProps, ref) => {
  const { layout, service = basic, onSuccess } = props;
  const [loading, setLoading] = useState(false);
  let Layout = Horizontal;
  if (layout === 'center') {
    Layout = Center;
  }
  useImperativeHandle(ref, () => ({
    logout: service.logout.bind(service),
  }));
  return (
    <LoginContext.Provider value={{ service, onSuccess, loading, setLoading }}>
      <Layout />
    </LoginContext.Provider>
  );
})

export default Login;
